import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { CourseDetailEntity, CourseDetailResponse, CourseEntity, CourseResponse, deserializeCourse, deserializeCourseDetail } from 'src/entities/Course.entity';

export const COURSES_BASE_PATH = '/api/v5/master/courses';
export const COURSES_QUERY_KEY = 'courses';
export const coursesQueryKey = () => [COURSES_QUERY_KEY, 'list'] as const;
export const courseQueryKey = (id: number) => [COURSES_QUERY_KEY, 'detail', id] as const;

/** コース一覧（有効・無効の両方。sort_order, id 昇順。deleted は API が出さない） */
export const useCoursesQuery = () => useQuery<CourseEntity[], Error>({
  queryKey: coursesQueryKey(),
  queryFn: async () => (await axios.get<CourseResponse[]>(COURSES_BASE_PATH)).data.map(deserializeCourse),
});

/** コース詳細（出庫・帰庫、紐付く便、ルートと地点）。id が null なら呼ばない */
export const useCourseQuery = (id: number | null) => useQuery<CourseDetailEntity, Error>({
  queryKey: courseQueryKey(id ?? 0),
  queryFn: async () => deserializeCourseDetail((await axios.get<CourseDetailResponse>(`${COURSES_BASE_PATH}/${id}`)).data),
  enabled: id != null,
});
